/**
 * Remembered preferences: the theme, the calculator's method choice, and for signed-in
 * people the group and experience (member or officer) they last used.
 *
 * The public share-out calculator never writes figures to browser storage ("Nothing you
 * enter leaves this phone"). Signed-in people are different by design: src/api/queryClient.ts
 * keeps her own figures under tisunge.cache.<personId> so the app opens offline with her
 * last balance (PRD 16), and wipes it at sign-out; src/session keeps tisunge.unlock (her
 * number, first name and unlock token) and src/api/client.ts keeps tisunge.device. (The router's
 * <ScrollRestoration /> also keeps scroll offsets in sessionStorage, under
 * "react-router-scroll-positions": positions only, never figures.)
 * Storage can be missing or blocked (private windows, previews), so every call is
 * wrapped and failures are ignored.
 */

const PREFIX = 'tisunge.'

export type PreferenceKey = 'theme' | 'palette' | 'calculator.method' | 'group' | 'mode'

export function readPreference(key: PreferenceKey): string | null {
  try {
    return window.localStorage.getItem(PREFIX + key)
  } catch {
    return null
  }
}

export function writePreference(key: PreferenceKey, value: string | null): void {
  try {
    if (value === null) window.localStorage.removeItem(PREFIX + key)
    else window.localStorage.setItem(PREFIX + key, value)
  } catch {
    // Not available: the preference simply is not remembered.
  }
}
